import Swiper, { EffectFade, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import { domContentLoadEvent } from '../common/domContentLoadEvent';

function initializeDifferentials(differentialsElement) {
    const swiperPagination = differentialsElement.querySelector('.swiper-pagination');
    const id = differentialsElement.getAttribute('data-id');
    new Swiper(differentialsElement.querySelector('.swiper'), {
        modules: [EffectFade, Pagination, Navigation],
        slidesPerView: 1,
        loop: true,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        pagination: {
            el: swiperPagination,
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next-diff-' + id,
            prevEl: '.swiper-button-prev-diff-' + id,
        },
    });
}

function initializeAllDifferentials() {
    document.querySelectorAll('.differentials-carousel').forEach(function (element) {
        initializeDifferentials(element);
    });
}

domContentLoadEvent(initializeAllDifferentials);
